
/* ------------------------------------------------------------------------------
 *
 *  # Bars with line for TEAMS - PER FACTOR MINI-CHARTS
 *
 * ---------------------------------------------------------------------------- */


var PromanaBarsLineLight__TEAMS_PF = function() {

    var _promanaChartLineBars__TEAMS_PF = function(args) {

        if (typeof echarts == 'undefined') {
            console.warn('Warning - echarts.min.js is not compiled');
            return;
        }

        var bars_mix_element = document.getElementById(args.anchor);

        if (bars_mix_element) {

            var bars_mix = echarts.init(bars_mix_element);

            bars_mix.setOption({

                textStyle: {
                    fontFamily: 'Roboto, Arial, Verdana, sans-serif',
                    fontSize: args.fontsize.global
                },

                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: args.legend,
                grid: {
                    left: 140
                },
                xAxis: args.x_axis,
                yAxis: args.y_axis,
                series: args.series,
                r_slugs: args.r_slugs,

            });
        }

        var opts = bars_mix.getOption();

        // Resize function
        var triggerChartResize = function() {
            bars_mix_element && bars_mix.resize();
        };

        // On sidebar width change
        var sidebarToggle = document.querySelectorAll('.sidebar-control');
        if (sidebarToggle) {
            sidebarToggle.forEach(function(togglers) {
                togglers.addEventListener('click', triggerChartResize);
            });
        }

        bars_mix.on('click', params => {
            if(params.targetType === "axisLabel"){
                var visible = $(".per-factor-chart").filter(".show");
                var letter = $(visible).find(".drilldown-desc ul").attr('factor');
                $(visible).find("li").prop('hidden',true);
                $("#perfactor-desc-"+letter+"-"+opts.r_slugs[params.value]).prop('hidden', false);
                Debug.log(letter);
            }
        });

        //on showing a modal
        $( ".modal" ).on('show.bs.modal', function(){
            setTimeout(function () {
                triggerChartResize();
            }, 200);
        });

        // On window resize
        var resizeCharts;
        window.addEventListener('resize', function() {
            clearTimeout(resizeCharts);
            resizeCharts = setTimeout(function () {
                triggerChartResize();
            }, 200);
        });
    };

    return {
        init: function(args) {
            _promanaChartLineBars__TEAMS_PF(args);
        }
    }
}();
